import {  postApi } from "./http.service";

export const sendNotification=async(payload:any)=>{
    return postApi('notification',payload);
}